import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
/** Keyboard shortcut label with institutional, non-monospace styling. */ export const SpecraKeyHint = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("kbd", {
        className: cn('font-sans text-[length:var(--fs-ui-micro)] font-normal tracking-[var(--ls-key-hint)] text-muted-foreground/70', className),
        ref: ref,
        ...props
    }));
SpecraKeyHint.displayName = 'SpecraKeyHint';
